import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'shared-list-item-expanded-template',
  standalone: true,
  imports: [NgClass],
  templateUrl: './list-item-expanded-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListItemExpandedTemplateComponent {
  configurableClasses = input<string | string[] | Set<string> | Record<string, boolean>>();
}
